import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { UserInfo } from '../models/user';
import { environment } from '../../environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler) {
    if (!request.url.toLowerCase().includes(environment.restAPI.urlSuffix.toLowerCase())) {
      return next.handle(request);
    }

    const storedUserInfo = sessionStorage.getItem('userInfo');
    const userInfo: UserInfo = storedUserInfo ? JSON.parse(storedUserInfo) : null;
    const tokenIsValid = userInfo
      && userInfo.sessionToken
      && userInfo.accessTokenExpiresAtUtc
      && new Date(userInfo.accessTokenExpiresAtUtc).getTime() > Date.now();

    const authenticatedRequest = tokenIsValid
      ? request.clone({ setHeaders: { Authorization: `Bearer ${userInfo.sessionToken}` } })
      : request;

    return next.handle(authenticatedRequest).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          sessionStorage.removeItem('userInfo');
          sessionStorage.removeItem('logonUserInfo');
          window.location.assign('/login');
        }
        return throwError(error);
      })
    );
  }
}